export default "__VITE_ASSET__fba88ba6__"